// Warning! Do not use this component directly in the app,
// it's used in the Switch component. Use SwitchOption component instead

import "./SwitchOption.scss"

import React, { FunctionComponent, ReactNode } from "react"
import cx from "classnames"
import Tooltip from "components/Tooltip/Tooltip"

interface ISwitchOptionInternalProps {
    isSelected?: boolean
    disabled?: boolean
    onClick: () => void
    tooltip?: ReactNode
}

const SwitchOptionInternal: FunctionComponent<React.PropsWithChildren<ISwitchOptionInternalProps>> = ({
    isSelected,
    disabled,
    onClick,
    tooltip,
    children,
}) => {
    function handleClick() {
        if (isSelected || disabled) return
        onClick()
    }

    const button = (
        <button
            type="button"
            className={cx([
                "switch-option__button",
                { "switch-option__button--selected": isSelected }
            ])}
            onClick={handleClick}
            disabled={disabled}>
            {children}
        </button>
    )

    return (
        <li className={cx([
            "switch-option",
            { "switch-option--with-tooltip": tooltip }
        ])}>
            {tooltip
                ? <Tooltip content={tooltip} trigger="hover">{button}</Tooltip>
                : button
            }
        </li>
    )
}

export default SwitchOptionInternal
